module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/hospital_detail/circle-d9d33eccf7f9910c7d00e34020326878.svg";